import { render, staticRenderFns } from "./needAddPhone.vue?vue&type=template&id=d5b5ccb2&scoped=true"
import script from "./needAddPhone.vue?vue&type=script&lang=js"
export * from "./needAddPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b5ccb2",
  null
  
)

export default component.exports